import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';

const ProdIOORetViewRow = (props) => {
    const { formObject, index, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn50">
                    <span>{index}</span>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemId" }} />
                </li>
                <li className="uiColumnCenter uiColumn200">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyReturned" }} />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "actionInvType" }} />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actionInvId", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
            </ul>
        )
}

export default ProdIOORetViewRow